import { Slot } from 'expo-router';
import { Provider as UrqlProvider } from 'urql';
import { authExchanges, getUrqlClient } from '@/client/urqlClient';

export default function AuthLayoutRoute() {
  const client = getUrqlClient({ key: 'auth', exchanges: authExchanges });

  return (
    <UrqlProvider value={client}>
      <Slot />
    </UrqlProvider>
  );
}
